import { render, staticRenderFns } from "./w-featured-testimonials.vue?vue&type=template&id=b701f6fe"
import script from "./w-featured-testimonials.vue?vue&type=script&lang=js"
export * from "./w-featured-testimonials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports